import { BoxProps } from '@jfs/ui-new'

export const styles = (breakpoint: number) => {
  let overRideFlex: BoxProps = {}
  let overRideTab: BoxProps = {}
  let overRideFlexRow: BoxProps = {}

  const shadowStyle = {
    shadowOffset: { width: 1, height: 1 },
    shadowRadius: 3,
    shadowColor: '#0000001F',
    borderRadius: 8,
    borderWidth: 1,
    borderColor: '#00000014',
    zIndex: 10,
  }

  if (breakpoint < 1000) {
    overRideFlex = {
      flexDirection: 'column',
      alignItems: 'flex-start',
    } as BoxProps
    overRideTab = {
      marginTop: 15,
    } as BoxProps
  }

  if (breakpoint < 600 && breakpoint > 460) {
    overRideFlexRow = {
      justifyContent: 'flex-start',
    } as BoxProps
  }

  if (breakpoint < 380) {
    overRideTab = {
      marginTop: 15,
      width: 300,
    } as BoxProps
  }
  return {
    container: {
      ...shadowStyle,
      padding: 16,
      minHeight: 5,
      backgroundColor: 'WHITE',
      paddingBottom: 10,
    } as BoxProps,
    row: {
      flexDirection: 'row',
      alignItems: 'center',
      backgroundColor: 'WHITE',
      justifyContent: 'space-between',
      marginTop: 16,
      ...overRideFlex,
    } as BoxProps,
    textContainer: {
      flexDirection: 'row',
      backgroundColor: 'WHITE',
    } as BoxProps,
    tabbar: {
      justifyContent: 'flex-start',
      backgroundColor: 'WHITE',
      ...overRideTab,
    } as BoxProps,
    listStyle: { flex: 1, justifyContent: 'space-between' } as BoxProps,
    flexRow: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      ...overRideFlexRow,
    } as BoxProps,
    modal: {
      position: 'absolute',
      elevation: 2,
      shadowOpacity: 1,
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      ...shadowStyle,
      zIndex: 1,
      borderWidth: 1,
      borderColor: 'GRAY_BORDER',
    } as BoxProps,
    overlayStyle: {
      backgroundColor: 'TRANSPARENT',
      width: '100%',
      height: '100%',
      justifyContent: 'center',
    } as BoxProps,
    dropdownStyle: (XAxisPos: number | undefined, yAxisPos: number | undefined, rightPos: number | undefined) =>
      ({
        position: 'absolute',
        flex: 1,
        shadowColor: 'BLACK_LIGHT',
        shadowOffset: {
          width: 0,
          height: 2,
        },
        shadowOpacity: 0.3,
        shadowRadius: 10,
        elevation: 2,
        left: XAxisPos,
        top: yAxisPos ? yAxisPos + 15 : undefined,
        borderRadius: 12,
        fetchUserList: 'BLUE',
        borderColor: 'SECONDARY_GREY',
        alignSelf: 'center',
        right: rightPos,
      } as BoxProps),
  }
}
